<template>
  <div>
    <v-dialog v-model="dialog" max-width="600px">
      <v-form ref="form" lazy-validation v-model="isValid" @submit.prevent>
        <v-card>
          <v-card-title class="justify-center">{{
            $t("payment.paymentConfirmation")
          }}</v-card-title>

          <v-divider></v-divider>
          <br />
          <v-card-text class="text-center">
            <span>
              {{ $t("payment.totalToPay") }}
              <strong
                style="margin-top: 10px; text-transform: uppercase; font-size: large;"
                >{{ formatPrice(amount) }}</strong
              >
            </span>
            <v-spacer></v-spacer>
            <br />

            <vue-select
              v-if="
                paymentMode === 'card' &&
                  paymentMethods.length > 0 &&
                  unpaidTotalPrice &&
                  settings &&
                  settings.paymentMethod === 'stripe'
              "
              id="vs2__combobox"
              v-model="selectedPaymentMethod"
              :options="paymentMethods"
              persistent-hint
              :getOptionLabel="
                paymentMethod =>
                  paymentMethod.cardLast4 !== -1
                    ? `**** **** **** ${paymentMethod.cardLast4}`
                    : $t('payment.addNewCard')
              "
              :clearable="false"
              :placeholder="$t('payment.selectYourCard')"
              :create-option="paymentMethod => paymentMethod"
              :reduce="paymentMethod => paymentMethod"
              @input="selectPaymentMethod($event)"
            ></vue-select>

            <v-card
              flat
              outlined
              class="mt-2"
              v-show="
                paymentMode === 'card' &&
                  amount &&
                  amount > 0 &&
                  settings &&
                  settings.paymentMethod === 'stripe'
              "
            >
              <v-card-subtitle>{{
                $t("payment.creditOrDebitCard")
              }}</v-card-subtitle>
              <v-card-text>
                <div id="card-element">
                  <!-- A Stripe Element will be inserted here. -->
                </div>

                <!-- Used to display Element errors. -->
                <div id="card-errors" class="red--text mt-2" role="alert"></div>
              </v-card-text>
            </v-card>

            <v-card-actions
              class="d-flex justify-center"
              v-if="settings && settings.paymentMethod === 'stripe'"
            >
              <stripe-checkout
                v-if="paymentMode === 'card'"
                ref="checkoutRef"
                :pk="publicKey"
                :items="stripeCheckoutItems"
                :success-url="successUrl"
                :cancel-url="cancelUrl"
                :locale="locale"
              >
              </stripe-checkout>

              <button
                :class="`checkout-button ${isDisabled ? 'disabled' : ''}`"
                :style="[
                  { 'border-radius': buttonBorderRadiusTheme },
                  { color: colorsGeneralPrimary },
                  { borderColor: colorsGeneralPrimary }
                ]"
                :disabled="isDisabled"
                @click="checkout"
              >
                <span>{{ $t("payment.pay") }}</span>
              </button>
            </v-card-actions>
            <div
              class="terms-condition-main"
              v-if="settings && settings.paymentMethod === 'redsys'"
            >
              <v-checkbox v-model="checkboxTermsCondition">
                <template v-slot:label>
                  <div>
                    &nbsp;
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <a target="_blank" href="/terms" @click.stop v-on="on">
                          {{ $t("payment.acceptTermsAndConditions") }}
                        </a>
                      </template>
                      {{ $t("payment.acceptTermsAndConditions") }}
                    </v-tooltip>
                  </div>
                </template>
              </v-checkbox>
            </div>

            <PaymentMethods
              :disable-payment-button="disablePaymentButton"
              :total-price="amount"
              v-if="settings && settings.paymentMethod === 'redsys'"
              :tableQR="tableQR"
              :unpaidTotalPrice="unpaidTotalPrice"
              :dividePayment="dividePayment"
            ></PaymentMethods>
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>
    <Loader
      :dialog-loader="dialogLoader"
      :message="this.$t('payment.redirectingToThePaymentprocess')"
    ></Loader>
  </div>
</template>
<script>
// eslint-disable-next-line no-undef
const stripe = Stripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY);
import Loader from "../../common/Loader";
import { StripeCheckout } from "vue-stripe-checkout";
import PaymentMethods from "@/components/public/payment/PaymentMethods";
export default {
  name: "CardPaymentDialog",
  props: ["isDisabled"],
  components: {
    StripeCheckout,
    Loader,
    PaymentMethods
  },
  data() {
    return {
      isValid: false,
      dialogLoader: false,
      amount: 0,
      dialog: false,
      paymentMode: null,
      paymentMethods: [],
      unpaidTotalPrice: 0,
      selectedPaymentMethod: null,
      card: null,
      publicKey: process.env.VUE_APP_STRIPE_PUBLIC_KEY,
      locale: "es",
      orders: [],
      dividePayment: "todo",
      checkboxTermsCondition: false
    };
  },
  computed: {
    tableQR() {
      return this.$store.state.tableQR
        ? this.$store.state.tableQR
        : localStorage.getItem("tableQR");
    },
    disablePaymentButton() {
      return !this.checkboxTermsCondition;
    },
    successUrl() {
      let selectedQR = this.$store.state.tableQR;
      return `${this.projectUrl}/success/{CHECKOUT_SESSION_ID}?qr=${selectedQR}`;
    },
    cancelUrl() {
      let selectedQR = this.$store.state.tableQR;
      return `${this.projectUrl}/?qr=${selectedQR}`;
    },
    stripeCheckoutItems() {
      let items = [];

      this.orders.forEach(product => {
        // eslint-disable-next-line no-unused-vars
        for (const [quantity, metadata] of Object.entries(product.metadata)) {
          if (!metadata.isPaid && metadata.isSelected) {
            let foundIndex = items.findIndex(x => x.sku === product.stripeSku);
            if (foundIndex === -1) {
              items.push({
                sku: product.stripeSku,
                quantity: 1
              });
            } else {
              items[foundIndex].quantity++;
            }
          }
        }
      });
      return items;
    }
  },
  mounted() {
    this.getPaymentMethods();
  },
  methods: {
    async checkout() {
      let self = this;
      // validate form
      if (this.dividePayment && !this.$refs.form.validate()) {
        return;
      }

      localStorage.setItem("lastLand", "checkout");

      // get total amount to be paid according to payment_type
      // let amount =
      //   this.dividePayment === "amount" ? this.amount : this.totalPrice;
      let amount = 0;
      if (this.dividePayment === "todo") {
        amount = this.unpaidTotalPrice;
        localStorage.setItem("payment_type", "todo");
      } else if (this.dividePayment === "amount") {
        amount = this.amount;
        localStorage.setItem("payment_type", "amount");
      } else {
        amount = this.totalPrice;
        localStorage.setItem("payment_type", "product");
      }

      localStorage.setItem(
        "missingAmountToPay",
        parseFloat(this.unpaidTotalPrice).toFixed(2)
      );
      localStorage.setItem("amountToBePaid", amount);
      localStorage.setItem("isPaid", "true");
      this.dialogLoader = true;

      if (
        this.selectedPaymentMethod &&
        this.selectedPaymentMethod.cardLast4 !== -1
      ) {
        try {
          // charge using existing card, payment_type could be any
          let response = await this.$api.stripe.chargeCustomer({
            amount: parseInt(amount * 100),
            currency: "eur",
            customer: this.selectedPaymentMethod.customerId,
            payment_method: this.selectedPaymentMethod.paymentMethod,
            error_on_requires_action: true,
            confirm: true
          });
          this.dialogLoader = false;

          if (this.dividePayment === "amount") {
            localStorage.setItem("payableProducts", "[]");
          }

          this.$router.push({
            path: "/success/_/",
            query: { externalId: response.id }
          });
        } catch (error) {
          // eslint-disable-next-line
          console.log(error);
          this.dialogLoader = false;
          this.errorMessage =
            error.response.data.error.message || "Something went wrong";
        }

        return;
      }

      if (this.dividePayment === "product") {
        // redirect to stripe checkout if payment type is products
        this.$refs.checkoutRef.redirectToCheckout();
        return;
      }

      if (
        (this.dividePayment === "todo" || this.dividePayment === "amount") &&
        this.amount &&
        this.amount > 0
      ) {
        // payment type is amount and requested to pay using new card
        stripe.createToken(this.card).then(async function(result) {
          if (result.error) {
            // Inform the customer that there was an error.
            const errorElement = document.getElementById("card-errors");
            errorElement.textContent = result.error.message;
            self.dialogLoader = false;
            return;
          }

          // Send the token to your server.
          try {
            const customer = await self.$api.stripe.createCustomer();
            const paymentIntent = await self.$api.stripe.createPaymentIntent({
              amount: parseInt(amount * 100),
              currency: "eur",
              customer: customer.id
            });
            self.stripeTokenHandler(customer, paymentIntent);
          } catch (error) {
            console.error(error);
          }
        });
      }
    },
    async stripeTokenHandler(customer, paymentIntent) {
      let self = this;
      try {
        stripe
          .confirmCardPayment(paymentIntent.client_secret, {
            payment_method: {
              card: this.card
            },
            setup_future_usage: "off_session"
          })
          .then(async function(result) {
            if (result.error) {
              // Show error to your customer
              // eslint-disable-next-line
              console.log(result.error.message);
              return;
            }

            if (result.paymentIntent.status === "succeeded") {
              try {
                await self.saveCard(customer, result.paymentIntent);
                localStorage.setItem("amountToBePaid", self.amount);
                localStorage.setItem("payableProducts", "[]");
                self.$router.push({
                  path: `/success/_/`,
                  query: {
                    externalId: paymentIntent.id
                  }
                });
              } catch (error) {
                console.error(error);
              }
            }
          });

        this.dialog = false;
      } catch (error) {
        console.error(error);
      } finally {
        this.dialogLoader = false;
      }
    },
    async saveCard(customer, paymentIntent) {
      // get public method from public intent
      let paymentMethod = await this.$api.stripe.getPaymentMethod(
        paymentIntent.payment_method
      );

      this.$store.commit("addPaymentMethod", {
        email: customer.email,
        paymentMethod: paymentMethod.id,
        customerId: customer.id,
        cardLast4: paymentMethod.card.last4
      });

      let localPaymentMethods = JSON.parse(
        localStorage.getItem("paymentMethods") || "[]"
      );

      let found = localPaymentMethods.find(
        x => x.cardLast4 === paymentMethod.card.last4
      );

      if (!found) {
        localPaymentMethods.push({
          email: customer.email,
          paymentMethod: paymentMethod.id,
          customerId: customer.id,
          cardLast4: paymentMethod.card.last4
        });
        localStorage.setItem(
          "paymentMethods",
          JSON.stringify(localPaymentMethods)
        );
      }
    },
    selectPaymentMethod(event) {
      // eslint-disable-next-line
      console.log(event);
      this.$emit("selectPaymentMethod", this.selectedPaymentMethod);
    },
    getPaymentMethods() {
      let self = this;
      let localPaymentMethods = JSON.parse(
        localStorage.getItem("paymentMethods") || "[]"
      );
      // eslint-disable-next-line no-unused-vars
      localPaymentMethods.forEach((item, index) => {
        self.$store.commit("addPaymentMethod", item);
      });
      if (localPaymentMethods.length > 0) {
        this.selectedPaymentMethod = localPaymentMethods.reverse()[0];
      }
    },
    openDialog(data) {
      this.dialog = true;
      this.paymentMode = data.paymentMode;
      this.paymentMethods = data.paymentMethods;
      this.unpaidTotalPrice = data.unpaidTotalPrice;
      this.amount = data.amount;
      this.orders = data.orders;
      this.dividePayment = data.dividePayment;
      this.totalPrice = data.totalPrice;
      setTimeout(() => {
        this.loadStripeElements();
      }, 1000);
    },
    loadStripeElements() {
      const elements = stripe.elements();

      // Custom styling can be passed to options when creating an Element.
      const style = {
        base: {
          // Add your base input styles here. For example:
          fontSize: "16px",
          color: "#32325d"
        }
      };

      // Create an instance of the card Element.
      this.card = elements.create("card", { style: style });

      // Add an instance of the card Element into the `card-element` <div>.
      this.card.mount("#card-element");
    }
  }
};
</script>
